import { useState } from 'react';
import { MarkdownContent } from '@backstage/core-components';
import { makeStyles, Tab, Tabs, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  tabs: { marginBottom: theme.spacing(3) },
  text: {
    overflowWrap: 'anywhere',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(17),
    lineHeight: 1.85,
    color: theme.palette.text.primary,
    '& h1, & h2, & h3, & h4': {
      lineHeight: 1.35,
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
    '& h1': { fontSize: '1.8em' },
    '& h2': { fontSize: '1.5em' },
    '& h3': { fontSize: '1.25em' },
    '& li': { marginBottom: theme.spacing(1) },
    '& pre': { overflowX: 'auto', padding: theme.spacing(2) },
    '& code': { fontSize: '0.9em' },
    '& blockquote': {
      margin: theme.spacing(2, 0),
      padding: theme.spacing(1, 2),
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.default,
    },
    '& table': { display: 'block', overflowX: 'auto', maxWidth: '100%' },
  },
  original: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    fontSize: theme.typography.pxToRem(15),
    lineHeight: 1.7,
    margin: 0,
    tabSize: 4,
  },
}));

function LargeDocumentNotice() {
  return (
    <Typography variant="body2" color="textSecondary">
      Documento extenso: aberto no conteúdo original para agilizar a leitura. A
      formatação pode levar alguns instantes.
    </Typography>
  );
}

export function SkillFormattedContent({ content }: { content: string }) {
  const classes = useStyles();
  // Avoid blocking the dialog on synchronous Markdown parsing of large documents.
  const largeDocument = content.length > 256 * 1024;
  const [mode, setMode] = useState(largeDocument ? 1 : 0);
  return (
    <>
      {largeDocument && <LargeDocumentNotice />}
      <Tabs
        value={mode}
        onChange={(_event, value) => setMode(value)}
        aria-label="Apresentação do conteúdo"
        className={classes.tabs}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          id="skill-formatted-tab"
          aria-controls="skill-content-panel"
          label="Formatado"
        />
        <Tab
          id="skill-original-tab"
          aria-controls="skill-content-panel"
          label="Conteúdo original"
        />
      </Tabs>
      <div
        role="tabpanel"
        id="skill-content-panel"
        aria-labelledby={
          mode === 0 ? 'skill-formatted-tab' : 'skill-original-tab'
        }
      >
        {mode === 0 ? (
          <MarkdownContent
            content={content}
            dialect="gfm"
            className={classes.text}
            transformImageUri={() => ''}
          />
        ) : (
          <pre className={classes.original}>{content}</pre>
        )}
      </div>
    </>
  );
}
